module.exports = __webpack_public_path__ + "static/kzv-ref-img-43a62e4c7b175a496811c60900de5865.png";